import React from "react";
import { useTranslate } from "@customHooks/useTranslate.js";
import Label from "@controls/Label.js";
const ImageButton = ({
  tran,
  className,
  category = null,
  buttonClassName = null,
  clicker,
  primary = false,
  hiddenOption = 0,
}) => {
  const classNames = [];
  const tranResult = useTranslate(tran, category);
  if (primary) {
    classNames.push("primary");
  }
  if (buttonClassName) {
    classNames.push(buttonClassName);
  }
  if (hiddenOption === 2) {
    classNames.push("hiddenOnMobile");
  }
  if (tran === "0" || !tran) {
    return (
      <button
        aria-label={className}
        className={classNames.length ? classNames.join(" ").trim() : null}
        type="button"
        onClick={clicker}
      >
        <span
          className={`ui-icon ${className} dark-icon${
            primary ? " primary" : ""
          }`}
        ></span>
      </button>
    );
  } else {
    return (
      <button
        aria-label={!tran || isNaN(tran) ? tran : tranResult}
        type="button"
        onClick={clicker}
        className={classNames.length ? classNames.join(" ").trim() : null}
      >
        <span
          className={`ui-icon ${className} dark-icon${
            primary ? " primary" : ""
          }`}
        ></span>
        <Label
          category={category}
          className={hiddenOption ? "hiddenOnMobile" : null}
          tranVal={tran}
        />
      </button>
    );
  }
};
export default ImageButton;
